import { FC } from 'react'
import { useRouterPush } from '@/client/hooks'
import { Calculator } from '@/client/submodules/Calculator'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { MoreInfos } from './MoreInfos'
import { ProductInfos } from './ProductInfos'
import * as S from './styles'
import { ProductProps } from './types'

export const CustomPageFile: FC<ProductProps> = ({
  seo,
  header,
  footer,
  content: {
    breadcrumb,
    show_calculator,
    name,
    description,
    benefits,
    cta,
    currency,
    minimum_price,
    image_type,
    product_image,
    featured_styles,
    inverse_color,
    product_information,
    product_information_redesign,
    tools_services,
    more_information
  }
}) => {
  const { defaultLocale } = useRouterPush()

  return (
    <Page seo={seo} header={header} footer={footer}>
      <Featured
        breadcrumb={breadcrumb}
        name={name}
        description={description}
        benefits={benefits}
        cta={cta}
        currency={currency}
        minimum_price={minimum_price}
        image_type={image_type}
        product_image={product_image}
        featured_styles={featured_styles}
        inverse_color={inverse_color}
      />

      {show_calculator && (
        <S.WrapCalculator id='calc'>
          <Calculator serviceType={defaultLocale || process.env.NEXT_PUBLIC_DEFAULT_LOCALE} />
        </S.WrapCalculator>
      )}

      <ProductInfos
        product_information={product_information}
        tools_services={tools_services}
        product_information_redesign={product_information_redesign}
      />

      <MoreInfos more_information={more_information} />
    </Page>
  )
}
